import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import SEO from '../SEO.js';
import './ServicePages.css';

const NursingAttendant = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Round-the-clock personal care and assistance',
    'Help with activities of daily living',
    'Companionship and emotional support',
    'Medication reminders and monitoring',
    'Reduced burden on family caregivers',
    'Personalized care in familiar surroundings'
  ];

  const services = [
    {
      name: '24/7 Care',
      description: 'Round-the-clock assistance for patients who need continuous monitoring and support.'
    },
    {
      name: 'Personal Care',
      description: 'Assistance with bathing, grooming, dressing, toileting, and other personal care needs.'
    },
    {
      name: 'Mobility Assistance',
      description: 'Help with walking, transferring, and positioning to prevent complications of immobility.'
    },
    {
      name: 'Medication Reminders',
      description: 'Timely reminders and assistance with taking prescribed medications.'
    }
  ];

  return (
    <div className="service-page nursing-attendant-page">
      <SEO 
        title="Nursing Attendant Services in Bangalore"
        description="Dedicated nursing attendant services in Bangalore. 24/7 personal care, mobility assistance, and medication reminders for elderly and patients at home."
        keywords="nursing attendant Bangalore, patient caretaker, elderly care attendant, home attendant service, 24/7 nursing care"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Nursing Attendant Services</h1>
                <p>Dedicated personal care assistants for your daily healthcare needs</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/nursing-attendant.jpg" alt="Nursing Attendant Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Dedicated Nursing Attendant Care</h2>
              <p>
                Our nursing attendants provide essential personal care and support for individuals who need assistance 
                with daily activities but don't require the specialized medical care of a registered nurse. 
                They are trained caregivers who help maintain comfort, hygiene, and quality of life.
              </p>
              <p>
                Whether you're recovering from surgery, managing a chronic condition, or need assistance due to 
                age-related limitations, our nursing attendants offer compassionate care tailored to your specific 
                needs, allowing you to maintain dignity and independence in your own home.
              </p>
              
              <h3>Our Nursing Attendant Services</h3>
              <Row className="treatment-cards">
                {services.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our Nursing Attendants Provide</h3>
              
            </div>
            <ul className="service-list">
                <li>Personal hygiene assistance (bathing, grooming)</li>
                <li>Dressing and undressing assistance</li>
                <li>Toileting and incontinence care</li>
                <li>Meal preparation and feeding assistance</li>
                <li>Mobility support and fall prevention</li>
                <li>Medication reminders</li>
                <li>Light housekeeping related to care</li>
                <li>Companionship and emotional support</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Nursing Attendants</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request a Nursing Attendant
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Nursing Attendants?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Thoroughly screened and trained caregivers</li>
                    <li>Personalized care plans for each client</li>
                    <li>Flexible scheduling options (hourly, daily, live-in)</li>
                    <li>Regular supervision and quality checks</li>
                    <li>Compassionate and respectful care approach</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Personal Care Assistance?</h3>
              <p>Our nursing attendants are ready to provide the daily support and care you need.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Nursing Attendant"
      />
    </div>
  );
};

export default NursingAttendant;
